import Div from '@/shared/Div';
import Heading from '@/shared/Heading';
import Paragraph from '@/shared/Paragraph';
import React from 'react';

type ProductNotFoundProps = {
  title?: string;
  subtitle?: string;
};

function ProductNotFound({ title = 'No products found' }: ProductNotFoundProps) {
  return (
    <Div className="text-center h-56 flex flex-col justify-center" dataTestId="product-not-found">
      <Heading level={3} className="text-hd-3 text-cti-secondary">
        {title}
      </Heading>
    </Div>
  );
}

export default React.memo(ProductNotFound);
